import { styled } from '@mui/material/styles'
import { Colors } from 'constants/colors'

const PageContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
})

const CardContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: '40px 0 0 0',
})

const PageInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
})
const PageTitle = styled('p')({
  fontSize: '38px',
  fontWeight: 700,
  color: Colors.white,
  letterSpacing: '1.2px',
  margin: '20px 0',
  padding: 0,
})

const PageSubtitle = styled('p')({
  fontsize: '14px',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: 0.7,
  margin: 0,
  padding: 0,
})
const SubPageStyle = {
  PageContainer,
  PageInfo,
  PageTitle,
  PageSubtitle,
  CardContainer,
}

export default SubPageStyle
